import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// 导入具体图标（推荐按需导入）
import { faGithub } from '@fortawesome/free-brands-svg-icons';



// 引入Font Awesome
import { faBars, faTimes, faCheckCircle, faStar,
  faMapMarker, faPhone, faEnvelope, faChevronDown, faArrowRight,
faCogs, faLineChart, faUsers, faShield } from '@fortawesome/free-solid-svg-icons'

library.add(faBars, faTimes, faCheckCircle, faStar,
    faMapMarker, faPhone, faEnvelope, faChevronDown,
    faGithub, faArrowRight, faCogs, faLineChart, faUsers, faShield)

export { FontAwesomeIcon };
